<template>
  <article class="card-911" data-slot="default">
    <img :src="image" :alt="alt"/>
    <slot>
      <h3>Using Science to brew the perfect cup of coffee</h3>
      <p>Science can do everything else, so why not use it to brew better coffe? Fugiat perspiciatis nobis omnis nisi
        necessitatibus sed accusamus, rem beatae cum quia odio velit architecto expedita, assumenda.</p>
    </slot>
  </article>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card911",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  }
}
</script>

<style scoped>
img {
  width: 100%;
  height: 150px;
  display: block;
  margin: 0 auto;
  padding: 0;
  object-fit: cover;
}

.card-911 {
  display: block;
  width: 100%;
  height: 400px;
  background-color: #fff;
  border-radius: 1.75rem;
  padding: 0.75rem;
  padding: 1rem;
  box-shadow: 0 16px 24px -12px rgba(0, 0, 0, 0.15);
}

.card-911 img {
  text-align: center;
  border-radius: 1.25rem;
  contain: contents;
  fit: fill-box;
  margin-bottom: 1rem;
  box-shadow: 0 16px 24px -12px rgba(0, 0, 0, 0.15);
}
</style>